import { Box, IconButton, Menu, MenuItem, withStyles } from '@material-ui/core';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { parseMessage } from '@src/locales/intl';
import { MediaType } from '@src/model/frontendmodel';
import { ChatEventMediaType } from '@src/types';
import { useState } from 'react';

const lblDownload = parseMessage('Console.Chat.Action.Download');

const MuiMenu = withStyles({
  paper: {
    boxShadow: `0px 5px 5px -3px rgba(0,0,0,0.2),
      0px 8px 10px 1px rgba(0,0,0,0.14),
      0px 3px 14px 2px rgba(0,0,0,0.12)`,
  },
})(Menu);

export type ChatMsgOption = {
  mediaType: ChatEventMediaType;
  mediaUrl?: string;
  isIncoming: boolean;
};

const ChatMessageOptions: React.FC<ChatMsgOption> = ({
  mediaType,
  mediaUrl,
  isIncoming,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMedia = MediaType.AUDIO === mediaType;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onSelect = (action?: string, url?: string | null) => {
    if (action === lblDownload) {
      fetch(url || '', { cache: 'no-store' })
        .then(response => response.blob())
        .then(blob => {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement('a'), {
            href,
            download: `audio-${mediaUrl?.slice(-16)}`,
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
        });
    }
    setAnchorEl(null);
  };

  if (isMedia)
    return (
      <>
        <Box>
          <IconButton
            size="small"
            color={isIncoming ? 'primary' : 'inherit'}
            aria-controls="muimenu-options"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreVertIcon />
          </IconButton>
        </Box>
        <MuiMenu
          id="muimenu-options"
          anchorEl={anchorEl}
          keepMounted={false}
          open={Boolean(anchorEl)}
          onClose={() => {
            onSelect();
          }}
          PaperProps={{
            style: {
              transform: 'translateX(10px) translateY(30px)',
            },
          }}
        >
          <MenuItem
            onClick={() => {
              onSelect(lblDownload, mediaUrl);
            }}
          >
            <Box sx={{ display: 'flex', gridGap: '1em' }}>
              <GetAppRoundedIcon fontSize="small" />
              {lblDownload}
            </Box>
          </MenuItem>
        </MuiMenu>
      </>
    );

  return null;
};

export default ChatMessageOptions;
